import { ArrowBack } from '@mui/icons-material'
import { useAuth } from 'contexts/auth'
import { Link, useHistory } from 'react-router-dom'
import { useStyles } from './styles'

interface IHeaderInfo {
  title: string
  subTitle?: string
  route?: string
  backRoute?: string
  customLabel?: string
}

const HeaderInfo = ({
  title,
  route = undefined,
  subTitle = undefined,
  backRoute = undefined,
  customLabel = '',
}: IHeaderInfo) => {
  const classes = useStyles()
  const history = useHistory()
  const { user } = useAuth()

  const linkLabel = `Criar ${title.toLowerCase()}`

  const handleBackPage = () => history.push(backRoute)

  return (
    <div className={classes.root}>
      {backRoute ? (
        <span className={classes.container}>
          <ArrowBack
            fontSize='small'
            color='primary'
            onClick={handleBackPage}
            sx={{ cursor: 'pointer' }}
          />
          <div className={classes.hero}>
            <span className={classes.title}>{title}</span>
            {subTitle && <span className={classes.subtitle}>{subTitle}</span>}
          </div>
        </span>
      ) : (
        <div className={classes.hero}>
          <span className={classes.title}>{title}</span>
          {subTitle && <span className={classes.subtitle}>{subTitle}</span>}
        </div>
      )}

      {route && user && (user.isSeller || user.isAdmin) && (
        <Link
          to={route}
          className={classes.button}
        >
          {customLabel === '' ? linkLabel : customLabel}
        </Link>
      )}
    </div>
  )
}

export default HeaderInfo
